<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24"> </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button @click="handleAdd" type="primary" icon="plus">新增</a-button>
      <a-button type="primary" icon="download" @click="handleExport()">导出</a-button>
      <a-upload name="file" :showUploadList="false" :multiple="false" :before-upload="beforeUpload">
        <a-button type="primary" icon="import">导入</a-button>
      </a-upload>
      <!-- 高级查询区域 -->
      <j-super-query
        :fieldList="superFieldList"
        ref="superQueryModal"
        @handleSuperQuery="handleSuperQuery"
      ></j-super-query>
      <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item key="1" @click="batchDel"><a-icon type="delete" />删除</a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px"> 批量操作 <a-icon type="down" /></a-button>
      </a-dropdown>
      <a-checkbox v-model="keepTree"> 导出时包含子节点 </a-checkbox>
    </div>

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择
        <a style="font-weight: 600">{{ selectedRowKeys.length }}</a
        >项
        <a style="margin-left: 24px" @click="onClearSelected">清空</a>
      </div>

      <a-table
        ref="table"
        size="middle"
        rowKey="id"
        class="j-table-force-nowrap"
        :scroll="{ x: true }"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        :expandedRowKeys="expandedRowKeys"
        @change="handleTableChange"
        @expand="handleExpand"
        v-bind="tableProps"
      >
        <template slot="imgSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px; font-style: italic">无图片</span>
          <img
            v-else
            :src="getImgView(text)"
            height="25px"
            alt=""
            style="max-width: 80px; font-size: 12px; font-style: italic"
          />
        </template>
        <template slot="fileSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px; font-style: italic">无文件</span>
          <a-button v-else :ghost="true" type="primary" icon="download" size="small" @click="downloadFile(text)">
            下载
          </a-button>
        </template>

        <span slot="action" slot-scope="text, record">
          <a @click="handleEdit(record)">编辑</a>

          <a-divider type="vertical" />
          <a-dropdown>
            <a class="ant-dropdown-link">更多 <a-icon type="down" /></a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a @click="handleAddChild(record)">添加下级</a>
              </a-menu-item>
              <a-menu-item>
                <a @click="handleCopy(record)">复制</a>
              </a-menu-item>
              <a-menu-item>
                <a @click="handleMove(record)">移动</a>
              </a-menu-item>
              <a-sub-menu key="sync" title="同步">
                <a-menu-item>
                  <a @click="handleSync(record)">同步自己</a>
                </a-menu-item>
                <a-menu-item>
                  <a @click="handleSyncChildren(record)">同步自己和孙子</a>
                </a-menu-item>
              </a-sub-menu>
               <a-menu-item>
                  <a-popconfirm
                    title="递归删除会删除所有子项,确定吗?"
                    @confirm="() => handleRecursionDeleteNode(record.id)"
                    placement="topLeft"
                  >
                    <a>删除</a>
                  </a-popconfirm>
                </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>
      </a-table>
    </div>

    <doFormCoreResource-modal ref="modalForm" @ok="modalFormOk"></doFormCoreResource-modal>
    <do-form-core-resource-list-modal ref="selectModal"></do-form-core-resource-list-modal>
  </a-card>
</template>

<script>
import { getAction, postAction, deleteAction, downFile, uploadAction } from '@/api/manage'
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import DoFormCoreResourceModal from './modules/DoFormCoreResourceModal'
import DoFormCoreResourceListModal from './modules/DoFormCoreResourceListModal.vue'
import { filterObj } from '@/utils/util'
import { doMistServerUrl } from '@/api/api'
import { axios } from '@/utils/request'

export default {
  name: 'DoFormCoreResourceList',
  mixins: [JeecgListMixin],
  components: {
    DoFormCoreResourceModal,
    DoFormCoreResourceListModal,
  },
  data() {
    return {
      description: '资源库管理页面',
      // 表头
      columns: [
        {
          title: '名称',
          align: 'left',
          dataIndex: 'name',
        },
        {
          title: '状态',
          align: 'left',
          dataIndex: 'status',
        },
        {
          title: '类型 folder--file',
          align: 'left',
          dataIndex: 'type',
        },
        {
          title: '根节点',
          align: 'left',
          dataIndex: 'rootId',
        },
        {
          title: '所在路径',
          align: 'left',
          dataIndex: 'path',
        },
        {
          title: '操作',
          dataIndex: 'action',
          align: 'center',
          fixed: 'right',
          width: 147,
          scopedSlots: { customRender: 'action' },
        },
      ],
      url: {
        list: `${doMistServerUrl}/doFormCoreResource/rootList`,
        childList: `${doMistServerUrl}/doFormCoreResource/childList`,
        getChildListBatch: `${doMistServerUrl}/doFormCoreResource/getChildListBatch`,
        delete: `${doMistServerUrl}/resource/deletePartResourceByIds`,
        deleteBatch: `${doMistServerUrl}/doFormCoreResource/deleteBatch`,
        deleteAllResourceById: `${doMistServerUrl}/resource/deleteAllResourceById`,
        exportXlsUrl: `${doMistServerUrl}/doFormCoreResource/exportXls`,
        importExcelUrl: `${doMistServerUrl}/doFormCoreResource/importExcel`,
        sync: `${doMistServerUrl}/syncIndex/sync/`,
        syncTree: `${doMistServerUrl}/syncIndex/syncTree/`,
        copy: `${doMistServerUrl}/manufacturer/copyTreeById`,
        move: `${doMistServerUrl}/manufacturer/moveTreeById`,
        export: `${doMistServerUrl}/resource/export`,
        import: `${doMistServerUrl}/resource/import`,
      },
      expandedRowKeys: [],
      hasChildrenField: 'hasChild',
      pidField: 'pid',
      dictOptions: {},
      loadParent: false,
      superFieldList: [],
      keepTree: true,
    }
  },
  created() {
    this.getSuperFieldList()
  },
  computed: {
    importUrl() {
      return `${this.url.import}`
    },
    tableProps() {
      let _this = this
      return {
        // 列表项是否可选择
        rowSelection: {
          selectedRowKeys: _this.selectedRowKeys,
          onChange: (selectedRowKeys) => (_this.selectedRowKeys = selectedRowKeys),
        },
      }
    },
  },
  methods: {
    loadData(arg) {
      if (arg == 1) {
        this.ipagination.current = 1
      }
      this.loading = true
      let params = this.getQueryParams()
      // params.hasQuery = 'true'
      getAction(this.url.list, params)
        .then((res) => {
          if (res.success) {
            let result = res.result
            if (Number(result.total) > 0) {
              this.ipagination.total = Number(result.total)
              this.dataSource = this.getDataByResult(res.result.records)
              return this.loadDataByExpandedRows(this.dataSource)
            } else {
              this.ipagination.total = 0
              this.dataSource = []
            }
          } else {
            this.$message.warning(res.message)
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    // 根据已展开的行查询数据（用于保存后刷新时异步加载子级的数据）
    loadDataByExpandedRows(dataList) {
      if (this.expandedRowKeys.length > 0) {
        return getAction(this.url.getChildListBatch, { parentIds: this.expandedRowKeys.join(',') }).then((res) => {
          if (res.success && res.result.records.length > 0) {
            //已展开的数据批量子节点
            let records = res.result.records
            const listMap = new Map()
            for (let item of records) {
              let pid = item[this.pidField]
              if (this.expandedRowKeys.join(',').includes(pid)) {
                let mapList = listMap.get(pid)
                if (mapList == null) {
                  mapList = []
                }
                mapList.push(item)
                listMap.set(pid, mapList)
              }
            }
            let childrenMap = listMap
            let fn = (list) => {
              if (list) {
                list.forEach((data) => {
                  if (this.expandedRowKeys.includes(data.id)) {
                    data.children = this.getDataByResult(childrenMap.get(data.id))
                    fn(data.children)
                  }
                })
              }
            }
            fn(dataList)
          }
        })
      } else {
        return Promise.resolve()
      }
    },
    getQueryParams(arg) {
      //获取查询条件
      let sqp = {}
      let param = {}
      if (this.superQueryParams) {
        sqp['superQueryParams'] = encodeURI(this.superQueryParams)
        sqp['superQueryMatchType'] = this.superQueryMatchType
      }
      if (arg) {
        param = Object.assign(sqp, this.isorter, this.filters)
      } else {
        param = Object.assign(sqp, this.queryParam, this.isorter, this.filters)
      }
      if (JSON.stringify(this.queryParam) === '{}' || arg) {
        param.hasQuery = 'false'
      } else {
        param.hasQuery = 'true'
      }
      param.field = this.getQueryField()
      param.pageNo = this.ipagination.current
      param.pageSize = this.ipagination.pageSize
      return filterObj(param)
    },
    searchReset() {
      //重置
      this.expandedRowKeys = []
      this.queryParam = {}
      this.loadData(1)
    },
    getDataByResult(result) {
      if (result) {
        return result.map((item) => {
          //判断是否标记了带有子节点
          if (item[this.hasChildrenField] == '1') {
            let loadChild = { id: item.id + '_loadChild', name: 'loading...', isLoading: true }
            item.children = [loadChild]
          }
          return item
        })
      }
    },
    handleExpand(expanded, record) {
      // 判断是否是展开状态
      if (expanded) {
        this.expandedRowKeys.push(record.id)
        if (record.children.length > 0 && record.children[0].isLoading === true) {
          let params = this.getQueryParams(1) //查询条件
          params[this.pidField] = record.id
          params.hasQuery = 'false'
          params.superQueryParams = ''
          getAction(this.url.childList, params).then((res) => {
            if (res.success) {
              if (res.result.records) {
                record.children = this.getDataByResult(res.result.records)
                this.dataSource = [...this.dataSource]
              } else {
                record.children = ''
                record.hasChildrenField = '0'
              }
            } else {
              this.$message.warning(res.message)
            }
          })
        }
      } else {
        let keyIndex = this.expandedRowKeys.indexOf(record.id)
        if (keyIndex >= 0) {
          this.expandedRowKeys.splice(keyIndex, 1)
        }
      }
    },
    handleAddChild(record) {
      this.loadParent = true
      let obj = {}
      obj[this.pidField] = record['id']
      this.$refs.modalForm.add(obj)
    },
    handleSync(record) {
      var that = this
      this.loading = true
      postAction(that.url.sync + record.id).then((res) => {
        this.loading = false
        if (res.success) {
          that.$message.success('同步成功')
        } else {
          that.$message.warning(res.message)
        }
      })
    },
    handleSyncChildren(record) {
      var that = this
      this.loading = true
      postAction(that.url.syncTree + record.id).then((res) => {
        this.loading = false
        if (res.success) {
          that.$message.success('同步成功')
        } else {
          that.$message.warning(res.message)
        }
      })
    },
    handleDeleteNode(id) {
      if (!this.url.delete) {
        this.$message.error('请设置url.delete属性!')
        return
      }
      var that = this
      postAction(that.url.delete, { ids: [id] }).then((res) => {
        if (res.success) {
          that.loadData(1)
        } else {
          that.$message.warning(res.message)
        }
      })
    },
    handleRecursionDeleteNode(id) {
      if (!this.url.deleteAllResourceById) {
        this.$message.error('请设置url.deleteAllResourceById!')
        return
      }
      var that = this
      deleteAction(that.url.deleteAllResourceById + `/${id}`).then((res) => {
        if (res.success) {
          that.loadData(1)
        } else {
          that.$message.warning(res.message)
        }
      })
    },
    batchDel() {
      if (this.selectedRowKeys.length <= 0) {
        this.$message.warning('请选择一条记录！')
        return false
      } else {
        let ids = ''
        let that = this
        that.selectedRowKeys.forEach(function (val) {
          ids += val + ','
        })
        that.$confirm({
          title: '确认删除',
          content: '是否删除选中数据?',
          onOk: function () {
            that.handleDeleteNode(ids)
            that.onClearSelected()
          },
        })
      }
    },
    getSuperFieldList() {
      let fieldList = []
      fieldList.push({ type: 'int', value: 'status', text: '状态', dictCode: '' })
      fieldList.push({ type: 'string', value: 'name', text: '名称', dictCode: '' })
      fieldList.push({ type: 'string', value: 'type', text: '类型 folder--file', dictCode: '' })
      fieldList.push({ type: 'string', value: 'pid', text: '父节点', dictCode: '' })
      fieldList.push({ type: 'string', value: 'rootId', text: '根节点', dictCode: '' })
      fieldList.push({ type: 'string', value: 'path', text: '所在路径', dictCode: '' })
      this.superFieldList = fieldList
    },
    async handleCopy(source) {
      const target = await this.$refs.selectModal.show()
      console.log(target)
      if (target) {
        const res = await postAction(this.url.copy, {
          area: target.target ? target.target : '1',
          fromId: source.id,
          toId: target.id,
        })
        if (res.success) {
          this.loadData(1)
          this.$message.success('复制成功')
        } else {
          this.$message.error('复制失败')
        }
      }
    },
    async handleMove(source) {
      const target = await this.$refs.selectModal.show()
      console.log(target)
      if (target) {
        const res = await postAction(this.url.move, {
          area: target.target ? target.target : '1',
          fromId: source.id,
          toId: target.id,
        })
        if (res.success) {
          this.loadData(1)
          this.$message.success('移动成功')
        } else {
          this.$message.error('移动失败')
        }
      }
    },
    async handleExport() {
      this.loading = true

      const res = await downFile(this.url.export, {
        includeGrandChildren: this.keepTree,
        resourceIds: this.selectedRowKeys.join(','),
      })
      const blob = new Blob([res], { type: 'application/octet-stream' })
      const href = URL.createObjectURL(blob)
      const _fileName = 'resource导出.json.gz'
      this.downloadEvt(href, _fileName)
      this.loading = false
    },
    downloadEvt(url, fileName = '未知文件') {
      const el = document.createElement('a')
      el.style.display = 'none'
      el.setAttribute('target', '_blank')
      /**
       * download的属性是HTML5新增的属性
       * href属性的地址必须是非跨域的地址，如果引用的是第三方的网站或者说是前后端分离的项目(调用后台的接口)，这时download就会不起作用。
       * 此时，如果是下载浏览器无法解析的文件，例如.exe,.xlsx..那么浏览器会自动下载，但是如果使用浏览器可以解析的文件，比如.txt,.png,.pdf....浏览器就会采取预览模式
       * 所以，对于.txt,.png,.pdf等的预览功能我们就可以直接不设置download属性(前提是后端响应头的Content-Type: application/octet-stream，如果为application/pdf浏览器则会判断文件为 pdf ，自动执行预览的策略)
       */
      fileName && el.setAttribute('download', fileName)
      el.href = url
      console.log(el)
      document.body.appendChild(el)
      el.click()
      document.body.removeChild(el)
    },
    beforeUpload(file) {
      this.fileList = [file]
      this.text = file.name
      this.loading = true
      this.doUpload(file)
      return false
    },

    async doUpload(file) {
      const formData = new FormData()
      formData.append('file', new Blob([file]))

      postAction(this.url.import, formData)

      this.loading = false
    },
  },
}
</script>
<style scoped>
@import '~@assets/less/common.less';
</style>

